import RouteConstants from '@/features/router/RouteConstants';
import { CampaignIcon, IconButton } from '@/lib';
import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { twMerge } from 'tailwind-merge';

type CreateCampaignCardProps = {
  className?: string;
};

export const CreateCampaignCard: FC<CreateCampaignCardProps> = ({ className }) => {
  const { t } = useTranslation();

  return (
    <section className={twMerge('rounded-xl bg-secondary-background p-8 shadow-sm', className)}>
      <div className='flex flex-col items-center gap-6'>
        <div className='grid gap-5'>
          <h3 className='text-4xl font-semibold text-quaternary-900'>
            <Trans i18nKey='home:createCampaignTitle'>
              <span className='text-brand-600'>Create</span> Campaign
            </Trans>
          </h3>
          <h4 className='text-base font-medium text-primary-900'>
            <Trans i18nKey='home:createCampaignSubtitle'>
              <strong>Increase engagement.</strong> Import your data to get started.
            </Trans>
          </h4>
        </div>
        <Link to={RouteConstants.createCampaign}>
          <IconButton text={t('ALL:startNow')} size='xl' leadingIcon={<CampaignIcon />}></IconButton>
        </Link>
      </div>
    </section>
  );
};
